import { render, staticRenderFns } from "./plansDropDown.vue?vue&type=template&id=6ff945a3&scoped=true"
import script from "./plansDropDown.vue?vue&type=script&lang=js"
export * from "./plansDropDown.vue?vue&type=script&lang=js"
import style0 from "./plansDropDown.vue?vue&type=style&index=0&id=6ff945a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff945a3",
  null
  
)

export default component.exports